import { useAuth } from 'contexts/AuthProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getItem } from 'utils/localStorageHelper';
import BindCloudAccount from './BindCloudAccount';
import UnbindCloudAccount from './UnbindCloudAccount';

interface AccoutTypeObject {
  isOwner: boolean;
  cloud: number;
  getUserInfo: VoidFunction;
}

const AccountType = ({ isOwner, cloud, getUserInfo }: AccoutTypeObject) => {
  const { t } = useTranslation();
  const { getUser } = useAuth();
  const [showBindModal, setShowBindModal] = useState<boolean>(false);
  const [showUnbindModal, setShowUnbindModal] = useState<boolean>(false);

  const onBindClick = () => {
    setShowBindModal(true);
  };

  const onUnBindClick = () => {
    setShowUnbindModal(true);
  };

  const resetForm = () => {
    setShowBindModal(false);
    setShowUnbindModal(false);
  };

  const updateUserProfile = () => {
    getUser();
    getUserInfo();
  };

  return (
    <>
      {isOwner && (
        <div className="label px-6 border-b border-slate-300">
          <label className="flex items-center label-text w-64">{t('profile.formAccountType')}</label>
          <p>{Boolean(cloud) === true ? t('profile.cloudAndLocalAccount') : t('profile.localAccount')}</p>
          {getItem('isFromCloud') !== 'true' &&
            (Boolean(cloud) === true ? (
              <button type="button" className="btn btn-link text-[#489EE5]" onClick={onUnBindClick}>
                {t('profile.removeCloudCredentials')}
              </button>
            ) : (
              <button type="button" className="btn btn-link text-[#489EE5]" onClick={onBindClick}>
                {t('profile.createCloudCredentials')}
              </button>
            ))}
        </div>
      )}
      {showBindModal && <BindCloudAccount resetForm={resetForm} updateUserProfile={updateUserProfile} />}
      {showUnbindModal && <UnbindCloudAccount resetForm={resetForm} updateUserProfile={updateUserProfile} />}
    </>
  );
};
export default AccountType;
